import UserApi from '../api/User';
import HomeApi from '../api/Home';

import PaymentMethod from '../models/PaymentMethod';
import { setPaymentMethodsFetchingStatus } from './loading';
import { fetchingStatuses } from '../reducers/loading';
import { handleUnauthorized } from './auth';

export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';
export const ERROR_ADDING_PAYMENT_METHODS = 'ERROR_ADDING_PAYMENT_METHODS';

export function setPaymentMethods(paymentMethods) {
    return {
        type: SET_PAYMENT_METHODS,
        payload: paymentMethods
    };
}

export function errorAddingPaymentMethod(error, code) {
    return {
        type: ERROR_ADDING_PAYMENT_METHODS,
        payload: {
            error,
            code
        }
    };
}

function mapPaymentMethods(response) {
    if (Array.isArray(response)) {
        return response.map((pm) => new PaymentMethod(pm));
    }
    return response;
}

export function fetchPaymentMethods() {
    return (dispatch, getState) => {
        dispatch(setPaymentMethodsFetchingStatus(fetchingStatuses.STARTED));
        const { accessToken } = getState().auth;
        return UserApi.getPaymentMethod(accessToken).then((response) => {
            response = mapPaymentMethods(response);
            dispatch(setPaymentMethods(response));
            dispatch(setPaymentMethodsFetchingStatus(fetchingStatuses.FINISHED));
        });
    };
}

function addPaymentMethod(payload, isFunnelCollection, couponName) {
    return (dispatch, getState) => {
        return handleUnauthorized(dispatch, async () => {
            const { accessToken } = getState().auth;
            let response;
            try {
                response = await UserApi.createPaymentMethod(accessToken, payload);
            } catch (error) {
                const errorAction = dispatch(errorAddingPaymentMethod(error.responseJSON, error.status));
                return Promise.reject(errorAction);
            }
            if (isFunnelCollection) {
                const dataPaymentMethod = {
                    'payment-method': {
                        psp: response.psp_name,
                        pm_id: response.id
                    },
                    ...(couponName && { coupon_name: couponName })
                };
                await HomeApi.pingCollectionHomePaymentMethod(dataPaymentMethod);
            }
            dispatch(fetchPaymentMethods());
        });
    };
}

export function addCreditCard(setupIntentId, isFunnelCollection = false, couponName = false) {
    const payload = {
        psp_name: 'stripe',
        intent_type: 'setup_intent',
        intent_id: setupIntentId
    };
    return addPaymentMethod(payload, isFunnelCollection, couponName);
}

export function addPaypal(
    braintreeNonce,
    braintreeDeviceData,
    isFunnelCollection = false,
    couponName = false
) {
    const payload = {
        psp_name: 'braintree',
        nonce: braintreeNonce,
        deviceData: braintreeDeviceData
    };
    return addPaymentMethod(payload, isFunnelCollection, couponName);
}
